import { Component, OnInit, Inject, PLATFORM_ID, Input, SimpleChanges, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/shared/services/common.service';
import { RootService } from 'src/app/shared/services/root.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { environment } from '../../../environments/environment';

declare var $;
@Component({
  selector: 'app-product-compare',
  templateUrl: './product-compare.component.html',
  styleUrls: ['./product-compare.component.scss']
})
export class ProductCompareComponent implements OnInit,OnChanges {
  @ViewChild('cardElement') cardElement: ElementRef;
  @Input() data: any;
  lobId = "Icv-Trucks";
  environment1 = environment.s3bucket.url;
  sub: Subscription = new Subscription();
  helpList: any;
  selectedAccountThree: any = "";
  modelDataThree: any;
  selectedTruckBusThree: any = "";
  productDetailsDataThree: any;
  productDetailsDataOne: any;
  selectedAccountOne: any = "";
  productDetailsDataTwo: any;
  showcursor: boolean = false;
  selectedTruckBusTwo: any = "";
  selectedAccountTwo: any = "";
  performanceOne: any;
  performanceTwo: any;
  performanceThree: any;
  isTruckImage: boolean = true;
  plpplList: any = [];
  groupedArray: any = [];
  card1: boolean = false;
  card2: boolean = false;
  card3: boolean = false;
  truckLobId: String = 'Icv-Trucks';
  busLobId: String = 'Buses';
  scvpickupLobId: String = 'SCVPickups';
  metatitle = "Tata Motors Truck & Buses Features Comparison - Tata Motors";
  metadesc = "Compare features, specifications and choose best truck or buses by Tata Motors. Know more about Tata Motors 4 wheelers On-Road price. ";
  btnName: any;
  showMenuCompare: boolean = false;
  modelDataTwo: any = [];
  id: any;
  lob: any;
  isUserLoggedIn: boolean = false;
  vc: any;
  groupedArray2: any;
  DataTwoArray: any;
  groupedArray3: any;
  DataThreeArray: any;
  constructor(private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private commonService: CommonService,
    private rootService: RootService,
    private behaviorService: BehaviourSubjectService, private router: Router, @Inject(PLATFORM_ID) private platformId: Object, private cleverService: ClevertapService, private localStorage: secureStorage) {

  }

  ngOnInit(): void {
    this.sub.add(this.route.queryParams.subscribe((params) => {
      if (params['dealer']) {
        if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem("dealercd", params['dealer']);
        localStorage.setItem("vc", params['vc']);
        }
        this.vc = params['vc']
      }
    }));
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Product Compare");
      } catch { }

    $('.header').addClass('p-scroll');
    }
    this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
    }));
    this.sub.add(this.route.params.subscribe((params: Params) => {
      this.id = params["id"];
      this.lob = params["lob_seo"];
      this.getTruckBusOne(this.id);

    }));
    if (this.lob == 'trucks') {
      this.getFindByDropDownsData('Icv Trucks');

    }
    if (this.lob == 'buses-vans') {
      this.getFindByDropDownsData('Buses');

    }
    if (this.lob == 'scv-pickups') {
      this.getFindByDropDownsData('Scv Pickups');

    }

  }

  getTruckBusOne(id: number) {
    this.card3 = false;
    this.showMenuCompare = false;
    this.productDetailsDataOne = null;
    let data;
    if (this.vc) {
      data = {
        vehicle_number: this.vc
      }
    }
    else {


      data = {
        product_id: id
      }
    }
          this.productDetailsDataOne = this.data
          this.compare();
          if (this.vc) {
            this.getFindByDropDownsData(this.productDetailsDataOne.sub_lob);

          }
          if (this.productDetailsDataOne["images"]) {
            if (this.productDetailsDataOne["images"].image_url) {
              this.productDetailsDataOne["imageUrl"] = this.productDetailsDataOne[
                "images"
              ].image_url;
              this.productDetailsDataOne.loaded = false;
            } else {
              this.productDetailsDataOne.images
                .filter((image: any) => image.is_cover === true)
                .map((img: any) => {
                  this.productDetailsDataOne["imageUrl"] = img["image_url"];
                  this.productDetailsDataOne.loaded = false;
                });
            }
          }
  }

  getFindByDropDownsData(lobid: any) {
    this.lobId = lobid;
    if (lobid === this.truckLobId) {
      this.btnName = "truck";
      this.isTruckImage = true;
    }
    if (lobid === this.busLobId) {
      this.btnName = "buses";
      this.isTruckImage = false;
    }
    if (lobid === this.scvpickupLobId) {
      this.btnName = "Scv Pickups";
      this.isTruckImage = false;
    }
    let jsn1 = { lob_name: lobid }
    this.sub.add(this.apiService.getDropDownList(jsn1).subscribe({
      next: (response: any) => {

        this.helpList = response["data"];
        if (response.success) {
          this.plpplList = response.data;
          let unique = [...new Set(this.plpplList.map((item: any) => item.ppl))];
          this.groupedArray = unique.map(i => ({
            name: i,
            values: this.plpplList.filter((d: any) => d.ppl === i)
          }))
          this.groupedArray2 = unique.map(i => ({
            name: i,
            values: this.plpplList.filter((d: any) => d.ppl === i)
          }))
          this.groupedArray3 = unique.map(i => ({
            name: i,
            values: this.plpplList.filter((d: any) => d.ppl === i)
          }))
          this.DataTwoArray= this.groupedArray2;
          this.DataThreeArray= this.groupedArray3;
          if (isPlatformBrowser(this.platformId)) {
          this.localStorage.setItem('groupedArray2',JSON.stringify(this.groupedArray))
          this.localStorage.setItem('groupedArray3',JSON.stringify(this.groupedArray))
          }
        } else {
          this.plpplList = [];
        }
      },
      error: () => {
      },
      complete: () => {
      }
    })
    );
  }

  getItemTwo(event: any) {
    let data: any = {};
    let value: any;
    this.modelDataTwo = [];
    this.productDetailsDataTwo = null;
    this.selectedTruckBusTwo = "";
    this.performanceTwo = "";
    this.plpplList.forEach(function (item: any) {
      if (item.pl == event.target.value) {
        value = item;
      }
    })
    data["start_row"] = 0;
    data["end_row"] = 18;
    data["lob_name"] = this.lobId ? this.lobId : "";
    data["ppl_name"] = value.ppl ? value.ppl : "";
    data["pl_name"] = value.pl ? value.pl : "";

    this.sub.add(this.apiService.getVehicleInfo(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.modelDataTwo = response["data"];
        }
      },
      error: () => {
      },
      complete: () => {
      }
    })
    );
  }

  getItemThree(event: any) {
    let data: any = {};
    let value: any;
    this.modelDataThree = [];
    this.productDetailsDataThree = null;
    this.selectedTruckBusThree = "";
    this.performanceThree = "";
    this.plpplList.forEach(function (item: any) {
      if (item.pl == event.target.value) {
        value = item;
      }
    })
    data["start_row"] = 0;
    data["end_row"] = 18;
    data["lob_name"] = this.lobId ? this.lobId : "";
    data["ppl_name"] = value.ppl ? value.ppl : "";
    data["pl_name"] = value.pl ? value.pl : "";

    this.sub.add(this.apiService.getVehicleInfo(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.modelDataThree = response["data"];
        }
      },
      error: () => {
      },
      complete: () => {
      }
    })
    );
  }
  generateTwoArray(){
    this.groupedArray2 = JSON.parse(this.localStorage.getItem('groupedArray2'))
    for(let i = 0; i < this.groupedArray2?.length; i++){
      if(this.groupedArray2[i].values?.length){
        this.DataTwoArray[i].values = this.groupedArray2[i].values.filter( item => (item.pl != this.selectedAccountOne))
      }
    }
  }
  generateThreeArray(){
    if (isPlatformBrowser(this.platformId)) {
    this.groupedArray3 = JSON.parse(this.localStorage.getItem('groupedArray3'))
    }
    for(let i = 0; i < this.groupedArray3?.length; i++){
      if(this.groupedArray3[i].values?.length){
        this.DataThreeArray[i].values = this.groupedArray3[i].values.filter( item => (item.pl != this.selectedAccountTwo && item.pl != this.selectedAccountOne))
      }
    }
  }
  getTruckBusThree() {
    this.card3 = false;
    this.showMenuCompare = false;
    this.productDetailsDataThree = null;
    this.sub.add(this.apiService.getVehicleDetails({ product_id: this.selectedTruckBusThree }).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.productDetailsDataThree = response["data"];
          if (this.productDetailsDataThree["images"]) {
            if (this.productDetailsDataThree["images"].image_url) {
              this.productDetailsDataThree["imageUrl"] = this.productDetailsDataThree[
                "images"
              ].image_url;
              this.productDetailsDataThree.loaded = false;
            } else {
              this.productDetailsDataThree.images
                .filter((image: any) => image.is_cover === true)
                .map((img: any) => {
                  this.productDetailsDataThree["imageUrl"] = img["image_url"];
                  this.productDetailsDataThree.loaded = false;
                });
            }
          }

          this.compare();

        }

      },
      error: () => {
      },
      complete: () => {
      }
    }));
  }

  getTruckBusTwo() {
    this.card3 = false;
    this.showMenuCompare = false;

    this.sub.add(this.apiService.getVehicleDetails({ product_id: this.selectedTruckBusTwo }).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.showcursor = true;
          this.productDetailsDataTwo = response["data"];
          if (this.productDetailsDataTwo["images"]) {
            if (this.productDetailsDataTwo["images"].image_url) {
              this.productDetailsDataTwo["imageUrl"] = this.productDetailsDataTwo[
                "images"
              ].image_url;
              this.productDetailsDataTwo.loaded = false;
            } else {
              this.productDetailsDataTwo.images
                .filter((image: any) => image.is_cover === true)
                .map((img: any) => {
                  this.productDetailsDataTwo["imageUrl"] = img["image_url"];
                  this.productDetailsDataTwo.loaded = false;
                });
            }
          }

          this.compare();
        }

      },
      error: () => {
      },
      complete: () => {
      }
    }));
  }

  compare() {

    this.showMenuCompare = true;
    let vcOne = null;
    let vcTwo = null;
    let vcThree = null;
    this.performanceOne = null;
    this.performanceTwo = null;
    this.performanceThree = null;
    if (this.productDetailsDataOne) {
      vcOne = this.productDetailsDataOne["vehicle_number"];
    }
    if (this.productDetailsDataTwo) {
      vcTwo = this.productDetailsDataTwo["vehicle_number"];
    }
    if (this.productDetailsDataThree) {
      vcThree = this.productDetailsDataThree["vehicle_number"];
    } let data = {};


    if (vcOne && vcTwo && !vcThree) {
      this.spinner.show();
      data = { vc_s: [vcOne, vcTwo] }
      if (vcOne == vcTwo) {
        this.spinner.hide();
        this.toastrService.warning("Choose different vehicles for comparison");
        this.productDetailsDataTwo = null;
        data = { vc_s: [vcOne] }
      }
    }
    if (vcTwo && vcThree && !vcOne) {
      this.spinner.show();
      data = { vc_s: [vcTwo, vcThree] }
      if (vcThree == vcTwo) {
        this.spinner.hide();
        this.toastrService.warning("Choose different vehicles for comparison");
        this.productDetailsDataThree = null;

        data = { vc_s: [vcTwo] }
      }
    }
    if (vcOne && vcThree && !vcTwo) {
      this.spinner.show();
      data = { vc_s: [vcOne, vcThree] }
      if (vcThree == vcOne) {
        this.spinner.hide();
        this.toastrService.warning("Choose different vehicles for comparison");
        data = { vc_s: [vcOne] }
      }
    }
    if (vcOne && vcTwo && vcThree) {
      this.spinner.hide();
      data = { vc_s: [vcOne, vcTwo, vcThree] }
      if ((vcOne == vcTwo == vcThree) || (vcOne == vcTwo) || (vcTwo == vcThree) || (vcOne == vcThree)) {
        data = { vc_s: [vcOne, vcTwo] }
        this.productDetailsDataThree = null;
        this.spinner.hide();
        this.toastrService.warning("Choose different vehicles for comparison");
      }

    }

    if (vcOne && !vcTwo && !vcThree) {
      this.spinner.show();
      data = { vc_s: [vcOne] }
    }

    this.sub.add(this.apiService.getCompareList(data).subscribe({
      next: (response: any) => {

        if (response["success"]) {
          this.spinner.hide();
          this.performanceOne = response["data"][0];
          this.performanceTwo = response["data"][1];
          if (response["data"]?.length == 3) {
            this.performanceThree = response["data"][2];
          }
        }
        else {
        }
      },
      complete: () => {
        this.spinner.hide();
      }
    }));

  }

  bookNow(item: any) {
    if (this.isUserLoggedIn) {
      let sublob = item.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (item.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : item.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = item.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      this.router.navigate(['/lead-booking/' + sublob + '/' + item.lob_seo + '/' + item.ppl_seo + '/' + model + '/' + item.id]);
    }
    else {
      let sublob = item.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (item.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : item.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = item.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('previousUrl', '/lead-booking/' + sublob + '/' + item.lob_seo + '/' + item.ppl_seo + '/' + model + '/' + item.id)
      }
      this.router.navigate(['/login/']);
    }
    this.clevertapBook(item);
  }
  clevertapBook(productDetailsData: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onBookNowButtonClick(productDetailsData["id"],
          productDetailsData["model"], productDetailsData['images'][0].image_url, "Top Navigation");
      }
      catch { }
    }

  }

  redirect() {
    if (this.productDetailsDataOne && this.productDetailsDataTwo) {
      this.commonService.compareVehicleOne = this.productDetailsDataOne['id'];
      this.commonService.tabSelected = this.productDetailsDataOne['sub_lob']

      this.commonService.compareVehicleThree = this.productDetailsDataThree ? this.productDetailsDataThree['id'] : '';
      this.commonService.compareVehicleTwo = this.productDetailsDataTwo['id'];

      this.router.navigate(['/compare/']);
    }
  }

  updateImageSize(imageUrl: string, element: HTMLElement, width?: number, height?: number): string {
    if (!isPlatformBrowser(this.platformId)) {
      return imageUrl;
    }
  
    if (!imageUrl) {
      return '';
    }
  
    if (!element) {
      return imageUrl;
    }

    try {
      // Get actual width & height of the card
      const actualWidth = width && width > 0 ? width : element.clientWidth || 300;  // Default to 300 if no width
      const actualHeight = height && height > 0 ? height : element.clientHeight || 200;  // Default to 200 if no height
    

      const imgWidth = Math.floor(actualWidth * 0.8);
      const imgHeight = Math.floor((imgWidth / 100) * 67);
    

      // Ensure the URL is properly formatted
      const baseUrl = imageUrl.split('/resize/')[0];  // Get the base URL without resize parameters
      if (!baseUrl) {
        return imageUrl;
      }

      const updatedUrl = `${baseUrl}/resize/${imgWidth}x${imgHeight}`;

      return updatedUrl;
    } catch (error) {
      return imageUrl;  // Return original URL if there's an error
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && !changes['data'].firstChange) {
      const newSpecification = changes['data'].currentValue;
      this.productDetailsDataOne=newSpecification
      this.compare();
    }
  }
}

